<template>
    <div class="row">
        <div class="col-md-4 form-group">
            <label for="b2b_partners" class="control-label">Partner B2B*</label>
            <select ref="b2b_partners" class="form-control" v-model="selectedPartnerId" name="partner_id" required>
                <option v-for="Partner in b2bPartners" :key="Partner.id" :value="Partner.id">
                    {{ Partner.name }}
                </option>
            </select>
        </div>
        <div class="col-md-2 form-group">
            <label for="departure_date" class="control-label" >Data di partenza*</label>
            <input class="form-control"  name="departure_date" required type="date" :min="minDate"/>
        </div>
        <div class="col-md-2 form-group">
            <label for="departure_time" class="control-label" >Ora di partenza*</label>
            <input class="form-control"  name="departure_time" required type="time" />
        </div>
        <div class="col-md-8 form-group">
            <label for="start_address" class="control-label">Indirizzo di partenza*</label>
            <input ref="start_address" class="form-control" required name="start_address" type="text" :value="selectedPartner.complete_address ? selectedPartner.complete_address : ''"/>

            <input type="hidden" id="start_country" name="start_country" :value="selectedPartner.country">
            <input type="hidden" id="start_lat" name="start_lat" :value="selectedPartner.lat">
            <input type="hidden" id="start_long" name="start_long" :value="selectedPartner.long">
            <input type="hidden" id="start_zip" name="start_zip" :value="selectedPartner.zip">
            <input type="hidden" id="start_region" name="start_region" :value="selectedPartner.region">
            <input type="hidden" id="start_number" name="start_number" :value="selectedPartner.number">
            <input type="hidden" id="start_province" name="start_province" :value="selectedPartner.province">
            <input type="hidden" id="start_city" name="start_city" :value="selectedPartner.city">
            <input type="hidden" id="start_address" name="start_address" :value="selectedPartner.address">
            <input type="hidden" id="start_google_place_id" name="start_google_place_id" :value="selectedPartner.google_place_id">

        </div>
        <div class="col-md-8 form-group">
            <label for="end_address" class="control-label">Indirizzo di arrivo*</label>
            <input ref="end_address" class="form-control" required name="end_address" type="text"/>

            <input type="hidden" id="end_country" name="end_country">
            <input type="hidden" id="end_lat" name="end_lat">
            <input type="hidden" id="end_long" name="end_long">
            <input type="hidden" id="end_zip" name="end_zip">
            <input type="hidden" id="end_region" name="end_region">
            <input type="hidden" id="end_number" name="end_number">
            <input type="hidden" id="end_province" name="end_province">
            <input type="hidden" id="end_city" name="end_city">
            <input type="hidden" id="end_address" name="end_address">
            <input type="hidden" id="end_google_place_id" name="end_google_place_id">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        b2bPartners: {
            type: Array,
            default: () => []
        },
    },
    data(){
        return {
            selectedPartnerId: false,
            selectedPartner: false,
            minDate: this.getTomorrowDate()
        }
    },
    mounted() {
        $(this.$refs.b2b_partners).select2().on("change", () => {
            this.selectedPartnerId = $(this.$refs.b2b_partners).val();
            this.selectedPartner  = this.b2bPartners.find(partner => partner.id == this.selectedPartnerId);
        });
        const startAddressAutocomplete = new google.maps.places.Autocomplete(this.$refs.start_address);
        const endAddressAutocomplete = new google.maps.places.Autocomplete(this.$refs.end_address);
        const Instance = this;
        startAddressAutocomplete.addListener('place_changed', function() {
            Instance.fillAddressFields(startAddressAutocomplete.getPlace());
        });
        endAddressAutocomplete.addListener('place_changed', function() {
            Instance.fillAddressFields(endAddressAutocomplete.getPlace(), false);
        });
    },
    beforeDestroy() {
        $(this.$refs.b2b_partners).select2("destroy");
    },
    methods: {
        getTomorrowDate() {
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            return tomorrow.toISOString().split("T")[0];
        },
        fillAddressFields(place, start = true) {
            if (!place || !place.address_components) return;

            const addressComponents = {
                country: 'country',
                administrative_area_level_1: 'region',
                administrative_area_level_2: 'province',
                locality: 'city',
                postal_code: 'zip',
                street_number: 'number',
                route: 'address',
                google_place_id: 'google_place_id'
            };
            document.getElementById((start ? 'start_' : 'end_') + 'lat').value = place.geometry.location.lat();
            document.getElementById((start ? 'start_' : 'end_') + 'long').value = place.geometry.location.lng();
            document.getElementById((start ? 'start_' : 'end_') + 'google_place_id').value = place.place_id

            let addressNumber = '';

            place.address_components.forEach(element => {
                element.types.forEach(type => {
                    if (type in addressComponents) {
                        const field = addressComponents[type];
                        let id = (start ? 'start_' : 'end_') + field;
                        const el = document.getElementById(id);

                        if (el) {
                            if (type === 'administrative_area_level_2' || type === 'country') {
                                el.value = element.short_name;
                            } else {
                                el.value = element.long_name;
                            }
                        }
                    } else if (type === 'street_number') {
                        addressNumber = element.long_name;
                    } else if (type === 'route') {
                        let id = (start ? 'start_' : 'end_') + 'address';
                        const el = document.getElementById(id);
                        if (el) {
                            el.value = `${element.long_name}, ${addressNumber}`;
                        }
                    }
                });
            });
        }
    },
    watch: {}
}
</script>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/orders/b2bPlaceAutocomplete.vue